module.exports = __webpack_public_path__ + "static/media/eg.faa462f7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/eg.png
// module id = 1839
// module chunks = 0